import { z } from 'zod';

import { Accordion } from './accordion';
import {
  AddressLookup,
  AddressRaw,
  BusinessIndustryOption,
} from './address-lookup';
import { BreadcrumbItem, Breadcrumbs } from './breadcrumbs';
import { CardsCarousel } from './cards-carousel';
import { CardsCarouselCard } from './cards-carousel-card';
import { CtaButton } from './cta-button';
import { DualOverlainImage } from './dual-overlain-image';
import { EmailOptIn } from './email-opt-in';
import { FaqItem } from './faq-item';
import { FlexboxContentContainer } from './flexbox-content-container';
import { FlexboxItem } from './flexbox-item';
import { Footer } from './footer';
import { HeroCarousel } from './hero-carousel';
import { Image } from './image';
import { ImageBanner } from './image-banner';
import { InlineImage } from './inline-image';
import { LayoutParagraphPage } from './layout-paragraph-page';
import { LayoutSection } from './layout-section';
import { LogoImage } from './logo-image';
import { PrimaryFooter, NestedSecondColumn } from './primary-footer';
import { PrimaryFooterColumn, BorderStyling } from './primary-footer-column';
import { PrimaryFooterLink } from './primary-footer-link';
import { ReusableContent } from './reusable-content';
import { RichText } from './rich-text';
import { RichTextLink } from './rich-text-link';
import { SocialMediaIcons } from './social-media-icons';
import { SubFooter } from './sub-footer';
import { SubFooterLink } from './sub-footer-link';
import { Test } from './test';
import { UnknownPType } from './unknown';
import { VideoModal } from './video-modal';
import { Wayfinder } from './wayfinder';

// it would be nice to use `z.discriminatedUnion` here, however with the class for
// UnknownPType, we can't do that, as a string property can't be used as a discriminator
export const PTypes = z.union([
  Breadcrumbs,
  CtaButton,
  CardsCarousel,
  CardsCarouselCard,
  DualOverlainImage,
  EmailOptIn,
  FaqItem,
  FlexboxContentContainer,
  FlexboxItem,
  Footer,
  HeroCarousel,
  Image,
  ImageBanner,
  InlineImage,
  LayoutParagraphPage,
  LayoutSection,
  LogoImage,
  PrimaryFooter,
  PrimaryFooterColumn,
  PrimaryFooterLink,
  ReusableContent,
  RichText,
  RichTextLink,
  SocialMediaIcons,
  SubFooter,
  SubFooterLink,
  SocialMediaIcons,
  Test,
  VideoModal,
  Accordion,
  UnknownPType,
  AddressLookup,
  Wayfinder,
]);

export type PTypes = z.infer<typeof PTypes>;

export {
  BorderStyling,
  BreadcrumbItem,
  Breadcrumbs,
  BusinessIndustryOption,
  CardsCarousel,
  CardsCarouselCard,
  CtaButton,
  DualOverlainImage,
  EmailOptIn,
  FaqItem,
  FlexboxContentContainer,
  FlexboxItem,
  Footer,
  HeroCarousel,
  Image,
  ImageBanner,
  InlineImage,
  LayoutParagraphPage,
  LogoImage,
  LayoutSection,
  NestedSecondColumn,
  PrimaryFooter,
  PrimaryFooterColumn,
  PrimaryFooterLink,
  ReusableContent,
  RichText,
  RichTextLink,
  SocialMediaIcons,
  SubFooter,
  SubFooterLink,
  Test,
  VideoModal,
  Wayfinder,
  Accordion,
  AddressLookup,
  AddressRaw,
  UnknownPType,
};
